import React from "react";
import { useTranslation } from "react-i18next";

const Header: React.FC = () => {
    const { t } = useTranslation("common");
    
    return (
        <section className="relative w-full h-screen">
        <img
          src="/img/header.webp"
          alt="Product"
          className="w-full h-full object-cover imgOverride m-0"
        />

        <div className="absolute inset-0 bg-black/40 flex flex-col justify-center items-start text-left px-8 md:px-16">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
            {t("header.title")}
          </h1>
          <a className="mt-4 px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition" href="#testimonies">
            {t("header.button")}
          </a>
        </div>
      </section>
    );
};

export default Header;